import React, {useEffect} from 'react';
import pageImg from "../assets/headers/menstruatiedisk.nl-kiezen-quiz-7.jpg";
import TextContainer from "../components/pageItems/pageDesignElements/textContainer/TextContainer";

function TermsAndConditions({headerImageHandler, pageTitleHandler}) {
    useEffect(() => {
        headerImageHandler(pageImg);
        pageTitleHandler("Algemene Voorwaarden Donaties");
    }, [headerImageHandler, pageTitleHandler]);
    return (
        <TextContainer>

            <h2>Algemene Voorwaarden Donaties</h2>

            <p> U doneert aan onderstaande ontvangende partij:
                menstruatiedisk.nl, onderhouden door Nynke Kloppenburg. Ingeschreven in het handelsregister van de Kamer
                van Koophandel onder nummer 30277889, hierna verder te noemen: menstruatiedisk.nl. Telefoon:
                06-48813006. Bereikbaarheid: maandag van 9:00 uur tot 11:00 uur. Email: nynke@cupkiezer.nl
            </p>
            <h3>Artikel 1. Definities</h3>
            <p>
                1.1. Donatie: Een door de gevende partij aan menstruatiedisk.nl geschonken geldbedrag, of goederen in
                natura.<br/>
                1.2. Donatieformulier: Middel om online een donatie te doen aan menstruatiedisk.nl.<br/>
                1.3. Gevende partij: De natuurlijke- of rechtspersoon die middels iDEAL, of middels een elektronische
                machtiging, via de website van menstruatiedisk.nl, een donatie doet aan menstruatiedisk.nl, of zich
                aanmeldt als regelmatige sponsor/donateur.<br/>
                1.4. Statuten: menstruatiedisk.nl heeft tot doel, het ondersteunen in de zoektocht naar jou ideale
                menstruatie-artikel.<br/>
                1.5. Online doneren: Het geven van geld middels een elektronisch betaalsysteem of via een elektronische
                machtiging via de website van menstruatiedisk.nl aan menstruatiedisk.nl.<br/>
                1.6. Ontvangende partij: De rechtspersoon menstruatiedisk.nl die op basis van de overeenkomst een
                donatie ontvangt welke gebruikt wordt ten behoeve van de uitvoering van de statuten.<br/>
                1.7. Overeenkomst: De overeenkomst op afstand tussen ontvangende partij en gevende partij. 1.8.
                Overeenkomst op afstand: Een overeenkomst waarbij in het kader van een door de ontvangende partij
                georganiseerd systeem voor doneren tot het sluiten van de overeenkomst uitsluitend gebruik gemaakt wordt
                van één of meer technieken voor communicatie op afstand.<br/>
            </p>

            <h3>Artikel 2. Toepasselijkheid</h3><p>
            2.1. Deze algemene voorwaarden zijn van toepassing op elke online donatie aan menstruatiedisk.nl.<br/>
            2.2. De gevende partij stemt, door online te doneren, in met deze algemene voorwaarden. 2.3.
            menstruatiedisk.nl behoudt zich het recht voor om de algemene voorwaarden tussentijds te kunnen wijzigen.
        </p>
            <h3>Artikel 3. Rechten ontvangende partij, menstruatiedisk.nl</h3><p>
            3.1. Online donaties komen volledig ten goede aan menstruatiedisk.nl.<br/>
            3.2. menstruatiedisk.nl is binnen haar statuten volledig vrij in het bestemmen van deze online donaties,
            rekening houdend met de eventuele wensen van de donateur met betrekking tot specifieke projecten.<br/>
            3.3. Het eigendom van het gedoneerde bedrag gaat over op menstruatiedisk.nl nadat het gedoneerde bedrag op
            de bankrekening van menstruatiedisk.nl is bijgeschreven.<br/>
            3.4. Aansprakelijkheid: menstruatiedisk.nl aanvaardt geen aansprakelijkheid voor schade aan de zijde van de
            gevende partij als gevolg van de door de gevende partij gedane donatie. De gevende partij vrijwaart
            menstruatiedisk.nl voor alle aanspraken van derden voor schade geleden door die derden als gevolg van de
            donatie van de gevende partij aan menstruatiedisk.nl.
        </p>


            <h3>Artikel 4. Rechten gevende partij</h3>
            <p>4.1. De gevende partij heeft geen recht informatie te verkrijgen over de voortgang van de projecten van
                menstruatiedisk.nl.
            </p>
            <h3>Artikel 5. Plichten menstruatiedisk.nl</h3>
            <p>
                5.1. menstruatiedisk.nl verplicht zich de ontvangen bedragen te besteden overeenkomstig de statuten.<br/>
                5.2. menstruatiedisk.nl neemt passende technische en organisatorische maatregelen ter beveiliging van de
                communicatie, de persoonsgegevens, de elektronische overdracht van data en online donaties en zorgt voor
                een veilige web- omgeving. Het betreft hier een inspanningsverplichting. menstruatiedisk.nl aanvaardt
                geen aansprakelijkheid uit hoofde van deze verplichting.<br/>
                5.3. Alle personen die namens menstruatiedisk.nl bevoegd zijn van de persoonsgegevens kennis te kunnen
                nemen, zijn gehouden aan geheimhouding van deze gegevens.
            </p>

            <h3> Artikel 6. Plichten gevende partij</h3>
            <p>
                6.1. Om een overeenkomst te sluiten met ontvangende partij moet gevende partij tenminste 18 jaren oud
                zijn. Door het aangaan van een overeenkomst verklaart de gevende partij dat hij aan deze leeftijdsgrens
                voldoet;<br/>
                6.2. Gevende partij die onder de 18 jaren oud is kan een online donatie of een online aanmelding als
                vaste sponsor/donateur alleen doen in bijzijn van en met goedkeuring van een ouder of voogd;<br/>
                6.3. De gevende partij geeft zijn correcte identiteitsgegevens op.<br/>
                6.4. De gevende partij verricht uitsluitend donaties met middelen waarover hij/zij mag beschikken en
                waarover hij/zij zeggenschap heeft.
            </p>

            <h3>Artikel 7. Verwerking persoonsgegevens</h3>
            <p>
                7.1. menstruatiedisk.nl verwerkt de door de gevende partij aan menstruatiedisk.nl verstrekte
                persoonsgegevens in overeenstemming met alle (wettelijke) voorschriften betreffende de te verwerken
                gegevens, daaronder in het bijzonder begrepen de voorschriften bij of krachtens de Wet Bescherming
                Persoonsgegevens gesteld.<br/>
                7.2. Deze persoonsgegevens worden door menstruatiedisk.nl verwerkt ten behoeve van het aangaan van
                donateurschappen, voor de aanvaarding en afwikkeling van overige begunstigingen, voor het informeren
                over de voortgang van de projecten, alsmede om te kunnen voldoen aan wettelijke verplichtingen.<br/>
                7.3. De gevende partij heeft het recht te controleren of de door menstruatiedisk.nl geregistreerde
                gegevens juist zijn, het recht op correctie, indien de gegevens niet juist blijken te zijn, en het recht
                op verwijdering van de geregistreerde gegevens.
            </p>
            <h3> Artikel 8. Slotbepalingen</h3>
            <p>
                8.1. De disclaimer en het privacy statement die menstruatiedisk.nl hanteert zijn onverkort van
                toepassing.<br/>
                8.2. Partijen verklaren dat Nederlands recht van toepassing is.
            </p>


        </TextContainer>
    );
}

export default TermsAndConditions;